// @flow
import React from "react";
import Icon, { type IconProps } from "../";

export default function Cup({
  fill = "currentColor",
  width = "16px",
  ...props
}: IconProps) {
  return (
    <Icon
      
      viewBox="0 0 27 33"
      fill={fill}
      width={width}
      {...props}
    >
      <path
        d="M258.33 765.53a8.22 8.22 0 0 0-8.22-8.13h-.06v8.13zm-8.22-9.88c5.5 0 9.97 4.47 9.97 9.95a9.97 9.97 0 0 1-19.93 0 9.97 9.97 0 0 1 9.96-9.95zm-13.1 9.95a13.12 13.12 0 0 0 26.22 0c0-3.7-1.55-7.05-4.04-9.44l1.44-2.02a.81.81 0 0 0-.2-1.14l-2.16-1.53a.82.82 0 0 0-1.14.2l-1.47 2.07a12.86 12.86 0 0 0-3.48-1.06v-.85c0-.53.45-.98.99-.98h.54a1 1 0 0 0 .98-.98v-2.99a.99.99 0 0 0-.98-.98h-7.19a.99.99 0 0 0-.99.98v3a1 1 0 0 0 .99.97h.54c.54 0 .99.45.99.98v.85c-1.32.2-2.56.6-3.71 1.17l-1.46-2.05a.82.82 0 0 0-1.14-.2l-2.16 1.53a.8.8 0 0 0-.2 1.14l1.47 2.07a13.04 13.04 0 0 0-3.85 9.26z"
        transform="translate(-237 -746)"
      />
    </Icon>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Tournaments/Timer.js